import { Tooltip, TooltipContent, TooltipTrigger } from '@skand/ui';
import { ReactNode } from 'react';
import { screenSizeDetector } from '../utils/screenSizeDetector';
import { Popover, PopoverContent, PopoverTrigger } from './Popover';

/**
 * Render tooltip on desktop, render popover on mobile, as tooltip does not work well on mobile
 */
export const PopoverOrTooltip = (props: { trigger: ReactNode; content: ReactNode }) => {
  const isDesktop = screenSizeDetector.useIsDesktop();

  if (isDesktop) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{props.trigger}</TooltipTrigger>
        <TooltipContent asChild>{props.content}</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Popover>
      <PopoverTrigger asChild>{props.trigger}</PopoverTrigger>
      <PopoverContent asChild>{props.content}</PopoverContent>
    </Popover>
  );
};
